import React, { Component } from 'react';
import ReportPage from './ReportPage';
import GlideChart from '../GlideChart';
import DOL from '../../img/img-dol.png';

class GlidePathsPage extends Component {
    render() {
        let asOfDate = this.props.dataManager.asOfDate;
        return (
            <ReportPage {...this.props} addBreak={true} title={this.props.optimalPage?"Optimal Glide Path Comparison":"Glide Path Comparison"} subtitle="Comparison of Equity Allocations and Associated Risks" pageNumber={this.props.pageNumber} className="glide-paths-page fund-selector">
                <div className="tip">
                    <p><img src={DOL} alt="DOL Tip" /></p>
                    <p>
                    There are considerable differences among TDFs offered by different providers, even among TDFs with the same target date. For example, TDFs may have different investment strategies, glide paths, and investment-related fees. Because these differences can significantly affect the way a TDF performs, it is important that fiduciaries understand these differences when selecting a TDF as an investment option for their plan.
                    </p>
                </div>
                    <GlideChart glides={this.props.dataManager.glides} funds={this.props.selectedFunds} id="glideChartReport" {...this.props} showOptimal={this.props.optimalPage?true:false} />
                <div style={{fontSize: "12px"}}>Data as of <span className="asOfDate">{asOfDate}</span></div>
                <div style={{fontSize: "12px"}}>Source: Morningstar, Fund Prospectuses, American Century Investments</div>
               

                { this.props.optimalPage && <div style={{fontSize: "12px"}}>Optimal Glide Path for savings/risk profile based on original research described in "On Optimal Allocations of Target-Date Funds" by Radu Gabudean, Francisco Gomes, Alexander Michaelides, and Yuxin Zhang appears in the Fall 2021 issue of The Journal of Retirement, © 2021, PMR. All rights reserved.<a target="_blank" href="https://www.pm-research.com/">https://www.pm-research.com/</a> Link to paper: <a target="_blank" href="https://www.americancentury.com/insights/optimal-glide-paths-new-research">https://www.americancentury.com/insights/optimal-glide-paths-new-research</a></div> }


    


            </ReportPage>
        );
    }
}

export default GlidePathsPage;
